/* nebe · outlet upsell po přidání do košíku — ostrá verze (Shopify, motiv Be Yours).
   Port mockupu mockup-outlet/upsell-pokladna/outlet-upsell.js, jehož chování prošlo sedmi
   koly QA. Data z window.NEBE_OUTLET (dodává sections/nebe-outlet-upsell.liquid).

   Tok: zákaznice přidá do košíku OUTLETOVÝ kus → místo sidecartu vyskočí popup se 2 barevně
   ladícími spodky a 1 premium kusem. Sidecart se vysune až po zavření popupu, ať zákaznice
   odejde jakkoli. Běžný (neoutletový) kus popup nespouští. Žádné slevy.

   ── NAPOJENÍ ───────────────────────────────────────────────────────────────────────────
   V assets/nebe-pdp.js ve funkci addToCart, uvnitř .then(response => …), na řádek TĚSNĚ PŘED
   `cart.renderContents(response); // otevře drawer Be Yours` vlož přesně tuhle jednu řádku:

     if (window.nebeOutlet && window.nebeOutlet.handleAdded(formData.get("id"), response)) return;

   Vrátí true jen tehdy, když je přidaný kus outletový a je co nabídnout: popup převezme
   kontrolu a drawer se NEOTEVŘE (otevřeme ho my, až se popup zavře). Jinak vrátí false
   a tok motivu pokračuje beze změny.

   ── BEZPEČNOST ─────────────────────────────────────────────────────────────────────────
   Popup stojí v cestě mezi přidáním do košíku a sidecartem, takže nesmí NIKDY nikoho
   zablokovat. Čtyři nezávislé pojistky, všechny končí otevřeným sidecartem, tedy tím,
   co by motiv dělal i bez tohohle elementu:
     1) vypínač NEBE_OUTLET.enabled / window.NEBE_OUTLET_ENABLED (zabírá i za běhu),
     2) URL override ?outlet_upsell=off / =on, uložený do localStorage,
     3) fail-open: celá rozhodovací i renderovací cesta je v try/catch, výjimka = rovnou drawer,
     4) watchdog: když se popup nevykreslí do 400 ms, otevře se rovnou drawer.
   Kdykoli vrátíme true, ručíme za to, že se sidecart otevře — na každé z těchto cest.

   ── MULTIJAZYČNOST ─────────────────────────────────────────────────────────────────────
   Barvy se párují přes colors[].key (handle), NIKDY přes přeložený řetězec: „Tělová | svítání"
   je v SK „Telová | svitanie" a porovnání řetězců by selhalo (rozbilo to už galerie na SK PDP).
   Ceny se zobrazují z priceFormatted a počítají z price. Adresy z window.routes / theme.routes
   kvůli jazykovým prefixům. Všechny texty z NEBE_OUTLET.texts, nic natvrdo. */
(function () {
  "use strict";

  /* ================= data ================= */
  var D = null;
  try { D = window.NEBE_OUTLET || null; } catch (e) { D = null; }
  if (!D) return;   // sekce nic nevydala → element neexistuje, motiv jede jako dřív

  var TX = (D && D.texts) || {};
  var SIZE_MAP = (D && D.sizeMap) || {};
  // Škála pro hledání nejbližší velikosti. Volitelný override z dat, jinak škála nebe.
  var SIZE_SCALE = (D && Array.isArray(D.sizeScale) && D.sizeScale.length)
    ? D.sizeScale.slice() : ["XS", "S", "M", "L", "XL", "XXL"];

  /* JEDNOTKY. Uvnitř se počítá výhradně v nejmenší jednotce měny (haléře/centy), protože
     tak chodí `price` i `compareAt` z Liquidu i `items_subtotal_price` z /cart.js.
     `freeShipThreshold` je JEDINÁ hodnota v hlavní jednotce (2500 = 2500 Kč), takže se
     hned na vstupu převede. Míchat obojí by znamenalo stonásobnou chybu v baru dopravy. */
  var THRESH = (Number(D && D.freeShipThreshold) || 0) * 100;

  /* Typ produktu, který spouští popup. Čte se z nastavení sekce, ať jde přejmenovat bez
     deploye JS. Porovnává se tolerantně k mezerám i velikosti písmen. */
  var OUTLET_TYPE = String((D && D.outletType) || "OUTLET").trim().toUpperCase();

  /* ================= texty =================
     Chybějící klíč vrací prázdný řetězec a volající prvek se schová. Nikdy „undefined"
     ani prázdné místo s rámečkem. Placeholdery {x}; kvůli snášenlivosti s locales se bere
     i %{x}. Texty smějí obsahovat <b>, proměnné se do nich escapují. */
  /* Texty smějí obsahovat zvýraznění, ale NESMĚJÍ otevřít dveře libovolnému HTML: chodí
     z locales i z nastavení sekce, kam dosáhne kdokoli s přístupem do administrace.
     Proto se šablona escapuje CELÁ a zpátky se pouští jen <b> a <strong> bez atributů.
       - „<b>" i „&lt;b&gt;" projdou stejně: je jedno, jestli Liquid vydá značku, nebo entitu,
         a právě na tomhle rozdílu se to na ostrém motivu rozbilo (značky se vypsaly jako text),
       - „<b onclick=…>" ani „<script>" neprojdou: regulár povoluje jen holou značku,
       - hodnoty (barva, velikost, počet) se escapují zvlášť na místě volání, takže se
         přes ně HTML propašovat nedá. */
  var RICH = /&lt;(\/?)(b|strong)&gt;/gi;
  function sanitize(s) {
    // 1) srovnej entitu na značku, ať je vstup jednotný bez ohledu na to, co vydal Liquid
    s = String(s).replace(RICH, "<$1$2>");
    // 2) escapuj všechno  3) a vrať zpátky jen povolené značky
    return esc(s).replace(RICH, "<$1$2>");
  }
  function fill(s, vars) {
    if (vars) Object.keys(vars).forEach(function (k) {
      s = s.split("{" + k + "}").join(vars[k]).split("%{" + k + "}").join(vars[k]);
    });
    return s;
  }
  // T() = pro innerHTML (zvýraznění se vykreslí)
  function T(key, vars) {
    var s = TX[key];
    if (typeof s !== "string" || !s) return "";
    return fill(sanitize(s), vars);
  }
  /* Tplain() = pro textContent a aria-label, kde by se značka vypsala doslova.
     Značky se zahodí a entity rozkódují tím, že se sanitizovaný text protáhne DOMem. */
  function Tplain(key, vars) {
    var html = T(key, vars);
    if (!html) return "";
    try {
      var d = document.createElement("div");
      d.innerHTML = html;
      return d.textContent || "";
    } catch (e) { return html.replace(/<\/?(b|strong)>/gi, ""); }
  }
  function has(key) { return typeof TX[key] === "string" && TX[key] !== ""; }

  /* ================= pomocné ================= */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  // Jost nemá tabulární číslice a tabular-nums na webu nefunguje → každá číslice do
  // .nebe-digit s pevnou šířkou, jinak ceny při přepočtu poskakují.
  function digits(str) {
    return String(str == null ? "" : str).replace(/\d/g, function (d) {
      return '<span class="nebe-digit">' + d + "</span>";
    });
  }
  function log(msg) { try { if (window.NEBE_OUTLET_DEBUG) console.log("[nebe-outlet]", msg); } catch (e) {} }

  // Průhledný 1×1 GIF: <img> v kartě nikdy neexistuje bez src, ani na jeden tik mezi
  // vytvořením šablony a dosazením fotky v renderColor(). Prázdný <img> vykreslí prohlížeč
  // jako rozbitý rámeček a v mockupu to byla hlídaná chyba.
  var BLANK_PX = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

  /* Shopify handleize pro párování barvy právě přidaného kusu s colors[].key.
     Diakritika se rozloží přes NFD a zahodí, zbytek nealfanumerického se sloučí do pomlčky.
     Sedí na to, co Liquid `| handleize` udělá s týmž řetězcem v témže jazyce. */
  function handleize(s) {
    var v = String(s == null ? "" : s).toLowerCase();
    try { v = v.normalize("NFD").replace(/[̀-ͯ]/g, ""); } catch (e) {}
    return v.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  /* Formát ceny pro DOPOČÍTÁVANÉ částky (zbývá do dopravy zdarma). Ceny produktů se berou
     hotové z priceFormatted, tohle je jediné místo v celém elementu, kde se částka skládá —
     a skládá se přes měnu aktivního košíku, ne natvrdo. Když se měna nebo formátovač
     nepodaří zjistit, vrací null a volající bar se rovnou schová: radši žádné číslo
     než číslo ve špatné měně.
     Vstup je v NEJMENŠÍ jednotce, stejně jako všude jinde uvnitř elementu. */
  var MONEY = (function () {
    try {
      var cur = (D && D.currency) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
      var loc = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || "cs";
      if (!cur) return null;
      // Bezdesetinné měny obchodu; u ostatních necháme Intl použít jeho výchozí počet míst.
      var zero = ["CZK", "HUF", "JPY", "KRW", "ISK"];
      var opt = { style: "currency", currency: cur };
      if (zero.indexOf(cur) >= 0) { opt.minimumFractionDigits = 0; opt.maximumFractionDigits = 0; }
      return new Intl.NumberFormat(loc, opt);
    } catch (e) { return null; }
  })();
  function money(minor) { return MONEY ? MONEY.format((Number(minor) || 0) / 100) : null; }

  /* Zobrazovaný název barvy. Reálná data nejsou konzistentní: tílko Stellar má „černá"
     minuskou, Dusk i Prism „Černá" majuskulí, takže by v jednom popupu stálo „černá" vedle
     „Bílá". Kapitalizuje se JEN první znak a jen pro zobrazení — párování jde vždycky přes
     key (handle) a téhle funkce se nikdy netýká. Mění se jeden znak, takže slovenské ani
     české tvary zbytku slova to nerozbije. */
  var DISPLAY_LOCALE = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || "cs";
  function capFirst(s) {
    s = String(s || "");
    if (!s) return "";
    try { return s.charAt(0).toLocaleUpperCase(DISPLAY_LOCALE) + s.slice(1); }
    catch (e) { return s.charAt(0).toUpperCase() + s.slice(1); }
  }
  function colorName(c) { return capFirst(c && (c.name || c.full)); }
  function colorFullName(c) { return capFirst(c && (c.full || c.name)); }

  /* ================= adresy ================= */
  /* Adresy: nejdřív ze sekce (Liquid je zná i s jazykovým prefixem trhu), pak z globálů
     motivu, teprve nakonec natvrdo. Natvrdo psané /cart/add.js mine jazykovou mutaci. */
  function route(sectionKey, themeKey, def) {
    try {
      if (D.routes && D.routes[sectionKey]) return D.routes[sectionKey];
      if (window.routes && window.routes[themeKey]) return window.routes[themeKey];
      if (window.theme && window.theme.routes && window.theme.routes[themeKey]) return window.theme.routes[themeKey];
    } catch (e) {}
    return def;
  }
  // .js si dolepujeme sami, takže případnou koncovku z dat napřed odřízneme (jinak /cart/add.js.js)
  function js(u) { return String(u).replace(/\.js$/, "") + ".js"; }
  var URL_ADD = js(route("cartAdd", "cart_add_url", "/cart/add"));
  var URL_CHANGE = js(route("cartChange", "cart_change_url", "/cart/change"));
  var URL_CART = String(route("cart", "cart_url", "/cart")).replace(/\.js$/, "");
  var URL_CART_JS = js(URL_CART);

  /* ================= KILLSWITCH ================= */
  /* Vypínač zabírá OKAMŽITĚ, i když ho někdo přehodí z konzole při incidentu: proto je to
     property se setterem, ne prostá proměnná. Vypnutí zavře i popup, který právě visí. */
  var LS_KEY = "nebe_outlet_enabled";
  var enabled = D.enabled !== false;

  function lsGet() { try { return localStorage.getItem(LS_KEY); } catch (e) { return null; } }
  function lsSet(v) { try { localStorage.setItem(LS_KEY, v); } catch (e) {} }

  try {
    Object.defineProperty(window, "NEBE_OUTLET_ENABLED", {
      configurable: true,
      get: function () { return enabled; },
      set: function (v) { enabled = v !== false; if (!enabled && isPopupOpen()) closePopup("killswitch"); }
    });
  } catch (e) {}

  /* ?outlet_upsell=off / =on přežije reload (localStorage), aby šel popup vypnout bez zásahu
     do kódu. Vypnuto znamená jen explicitní „off": jakákoli jiná hodnota je nesmysl po někom
     v devtools, bereme ji jako zapnuto a rovnou ji opravíme, ať se killswitch nechová jako záhada. */
  (function readUrlOverride() {
    try {
      var v = new URLSearchParams(location.search).get("outlet_upsell");
      if (v === "off" || v === "on") { lsSet(v); enabled = v === "on"; return; }
      var saved = lsGet();
      if (saved === null) return;
      if (saved === "off") { enabled = false; return; }
      // „on" v localStorage nikdy nepřebije vypnutí ze sekce, to hlídá isEnabled()
      if (saved === "on") { enabled = true; return; }
      lsSet("on");
      log("neznámá hodnota killswitche v localStorage: " + saved + ", beru jako ZAP a opravuji");
    } catch (e) {}
  })();
  function isEnabled() { return enabled === true && D.enabled !== false; }

  /* ================= měření =================
     Bez měření nejde poznat, jestli popup přidává tržbu, nebo jen přebarvuje nákupy, co by
     se staly tak jako tak. Tři vrstvy, stejné jako u shopify-nebe-upsell:
       1) atribuce přes line item properties (_upsell_source apod.), viz addProps(),
       2) holdout: části návštěvnic se popup nezobrazí, ale „eligible" se zaloguje,
          takže jde spočítat inkrementalita. Bucket je v localStorage, aby byl stálý.
       3) telemetrie přes Shopify.analytics.publish, kterou odchytí Web Pixel.
     Holdout NIKDY neruší přidání do košíku: vrací se false a drawer otevře motiv sám. */
  var BUCKET = (function () {
    var pct = Number(D && D.holdoutPct) || 0;
    if (pct <= 0) return "test";
    try {
      var k = "nebe_outlet_bucket", b = localStorage.getItem(k);
      if (b !== "test" && b !== "holdout") {
        b = (Math.random() * 100 < Math.min(50, pct)) ? "holdout" : "test";
        localStorage.setItem(k, b);
      }
      return b;
    } catch (e) { return "test"; }
  })();
  function track(ev, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish("nebe_outlet_" + ev, Object.assign({ bucket: BUCKET }, data || {}));
      }
    } catch (e) {}
  }

  /* Bar dopravy zdarma v POPUPU je výchozím nastavením vypnutý (na webu běží doprava zdarma
     na ČR, slib „přihoď si ještě za X" by byl nepravdivý). Při vypnutém se nic nepočítá ani
     nehlásí. Bar v sidecartu tím dotčený NENÍ, ten patří motivu. */
  function shipBarOn() { return D.shipBar === true && THRESH > 0 && !!MONEY; }

  /* ================= stav ================= */
  var state = {
    offered: null,        // aktuální nabídka v popupu
    anchor: null,         // { handle, title, colorKey, colorValue, size, key }
    anchorGone: false,    // kotevní kus zmizel z košíku (cizí zásah během popupu)
    cartTotal: 0,         // items_subtotal_price v hlavní jednotce měny
    lastResponse: null,   // poslední odpověď košíku, ze které umí motiv vykreslit drawer
    lastFocused: null     // kam vrátit fokus: místo NA STRÁNCE, nikdy uvnitř popupu
  };
  var cardRegistry = [];
  var busyAdds = 0;

  var cartHandles = {};   // handly produktů už v košíku → v nabídce se nenabízejí
  function rememberCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    cartHandles = {};
    cart.items.forEach(function (it) { if (it && it.handle) cartHandles[it.handle] = true; });
    if (typeof cart.items_subtotal_price === "number") state.cartTotal = cart.items_subtotal_price / 100;
    else if (typeof cart.total_price === "number") state.cartTotal = cart.total_price / 100;
    /* Kotva se hledá přes HANDLE, ne přes klíč řádku: Shopify slévá shodné varianty do
       jednoho řádku a klíč se tím změní, takže by kotva vypadala jako zmizelá a velikostní
       hint by zmlkl uprostřed otevřeného popupu, aniž by se v košíku cokoli stalo. */
    if (state.anchor && state.anchor.handle) {
      state.anchorGone = !cart.items.some(function (it) { return it && it.handle === state.anchor.handle; });
    }
  }

  /* ================= DOM ================= */
  /* Markup umí dodat sekce. Když ho nedodá (nebo ho někdo vypne v Customizeru), postavíme
     si ho sami: element pak nezmizí kvůli cizímu nastavení, jen se vykreslí bez Liquidu.
     Oba kořeny přesouváme pod <body>, protože odstínění stránky přes inert jede po přímých
     potomcích body — popup uvnitř odstíněné sekce by se stal nefokusovatelným. */
  var SKELETON =
    '<div class="nou-pop__bg" data-nou-close></div>' +
    '<div class="nou-pop__panel" role="dialog" aria-modal="true" aria-labelledby="nouPopTitle" id="nouPopPanel">' +
      '<button type="button" class="nou-pop__x" data-nou-close id="nouPopX">&times;</button>' +
      '<div class="nou-pop__head">' +
        '<p class="nou-pop__thanks" id="nouThanks"></p>' +
        '<h2 class="nou-pop__title" id="nouPopTitle"></h2>' +
        '<p class="nou-pop__proof" id="nouProof" hidden></p>' +
      "</div>" +
      '<div class="nou-pop__ship" id="nouPopShip" hidden>' +
        '<p class="nou-pop__shipmsg" id="nouPopShipMsg"></p>' +
        '<div class="nou-ship__track"><i class="nou-ship__fill" id="nouPopShipFill"></i></div>' +
      "</div>" +
      '<div class="nou-cards" id="nouCards"></div>' +
      '<footer class="nou-pop__foot">' +
        '<button type="button" class="nou-pop__skip" data-nou-close id="nouSkip"></button>' +
        '<button type="button" class="nou-pop__go" id="nouGo" hidden></button>' +
      "</footer>" +
    "</div>";

  var popEl = null, toastEl = null;
  function ensureDom() {
    if (popEl && popEl.isConnected) return true;
    popEl = $("#nouPop");
    if (!popEl) {
      popEl = document.createElement("div");
      popEl.id = "nouPop";
      popEl.className = "nou-root nou-pop";
      popEl.hidden = true;
      popEl.innerHTML = SKELETON;
      document.body.appendChild(popEl);
    } else {
      popEl.classList.add("nou-root");
      if (!$("#nouPopPanel", popEl)) popEl.innerHTML = SKELETON;
      // Podkladový prvek je i klikací plochou. Kdyby ho markup sekce neměl, doplníme ho,
      // ať je chování zavírání stejné bez ohledu na to, co Liquid vydal.
      if (!$(".nou-pop__bg", popEl)) {
        var bg = document.createElement("div");
        bg.className = "nou-pop__bg";
        bg.setAttribute("data-nou-close", "");
        popEl.insertBefore(bg, popEl.firstChild);
      }
      if (popEl.parentNode !== document.body) document.body.appendChild(popEl);
    }
    toastEl = $("#nouToast");
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.id = "nouToast";
      toastEl.className = "nou-root nou-toast";
      toastEl.setAttribute("role", "status");
      toastEl.setAttribute("aria-live", "polite");
      toastEl.hidden = true;
      document.body.appendChild(toastEl);
    } else {
      toastEl.classList.add("nou-root");
      if (toastEl.parentNode !== document.body) document.body.appendChild(toastEl);
    }
    if (has("close")) $$("[data-nou-close]", popEl).forEach(function (b) {
      if (b.tagName === "BUTTON") b.setAttribute("aria-label", Tplain("close"));
    });
    return true;
  }
  function isPopupOpen() { return !!(popEl && !popEl.hidden); }

  /* Mobilní vzhled se řídí třídou na kořeni, ne media query — stejně jako v mockupu, takže
     se dá vynutit i na širokém okně (QA, Customizer preview). 89 % provozu je mobil. */
  function applyView() {
    if (!popEl) return;
    var mob = window.innerWidth <= 760;
    popEl.classList.toggle("nou-view-mobile", mob);
    if (toastEl) toastEl.classList.toggle("nou-view-mobile", mob);
  }
  window.addEventListener("resize", function () { try { applyView(); } catch (e) {} });

  var toastT;
  function toast(msg) {
    if (!msg || !toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.hidden = true; }, 2600);
  }

  /* ================= košík motivu ================= */
  /* Drawer patří motivu. Nikdy ho neschováváme ručně: otevíráme i zavíráme ho jeho vlastním
     API, jinak by se rozešel stav (details[open], trap fokusu, třídy na body). */
  function themeCart() {
    return document.querySelector("mini-cart") ||
           document.querySelector("cart-drawer") ||
           document.querySelector("cart-notification");
  }
  function themeDrawer() { return document.querySelector("cart-drawer") || themeCart(); }

  function sectionIds() {
    var c = themeCart();
    try {
      if (c && typeof c.getSectionsToRender === "function") {
        return c.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}
    return [];
  }
  function hasAllSections(resp) {
    var ids = sectionIds();
    if (!resp || !resp.sections || !ids.length) return false;
    for (var i = 0; i < ids.length; i++) if (typeof resp.sections[ids[i]] !== "string") return false;
    return true;
  }

  function closeThemeCart() {
    try {
      var d = themeDrawer();
      if (!d) return;
      // MenuDrawer.closeMenuDrawer ignoruje volání bez události, proto vlastní událost
      if (typeof d.closeMenuDrawer === "function") d.closeMenuDrawer(new CustomEvent("nebe-outlet"));
      else if (typeof d.close === "function") d.close();
    } catch (e) {}
  }

  /* Otevření sidecartu = mechanismus motivu (renderContents → open), ne vlastní panel.
     Odpověď musí nést `sections`, jinak by renderContents spadl na undefined. Když chybí,
     dotáhneme je Section Rendering API; když ani to nevyjde, spadneme na čisté otevření
     drawera a v úplně nejhorším případě na /cart. Žádná z těch cest nesmí skončit tím,
     že zákaznice po zavření popupu nevidí košík. */
  var cartOpened = false;
  function openThemeCart(reason) {
    if (cartOpened) return;
    cartOpened = true;
    log("otevírám sidecart: " + reason);
    var c = themeCart();
    if (!c) { location.href = URL_CART; return; }

    try { if (typeof c.setActiveElement === "function") c.setActiveElement(state.lastFocused || document.body); } catch (e) {}

    function render(resp) {
      try {
        if (c.classList && c.classList.contains("is-empty")) c.classList.remove("is-empty");
        c.renderContents(resp);
        focusIntoCart();
        return true;
      } catch (e) { return false; }
    }
    function bareOpen() {
      try {
        if (typeof c.open === "function") { c.open(); focusIntoCart(); return; }
        if (typeof c.openMenuDrawer === "function") { c.openMenuDrawer(); focusIntoCart(); return; }
      } catch (e) {}
      location.href = URL_CART;
    }

    if (typeof c.renderContents !== "function") { bareOpen(); return; }
    if (hasAllSections(state.lastResponse) && render(state.lastResponse)) return;

    var ids = sectionIds();
    if (!ids.length) { bareOpen(); return; }
    var done = false;
    var guard = setTimeout(function () { if (!done) { done = true; bareOpen(); } }, 2500);
    fetch(location.pathname + "?sections=" + encodeURIComponent(ids.join(",")), {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        if (done) return;
        done = true; clearTimeout(guard);
        if (!render({ sections: secs })) bareOpen();
      })
      .catch(function () { if (!done) { done = true; clearTimeout(guard); bareOpen(); } });
  }

  /* Po zavření popupu nesmí fokus zůstat na <body> ani uvnitř právě schovaného popupu.
     MiniCart motivu si fokus sám nepřebírá (open() volá openMenuDrawer bez summary prvku),
     tak ho tam dovedeme. Zkouší se dvakrát, protože motiv drawer otevírá řetězem setTimeoutů
     a hned po renderContents v něm ještě není nic fokusovatelného. Na transitionend se
     nečeká: v automatizovaném prohlížeči ani při prefers-reduced-motion nedojede. */
  function focusIntoCart() {
    var tries = 0;
    (function attempt() {
      setTimeout(function () {
        try {
          var a = document.activeElement;
          var lost = !a || a === document.body || (popEl && popEl.contains(a));
          if (!lost) return;
          var c = themeCart();
          var target = c ? focusables(c)[0] : null;
          if (!target && ++tries < 3) return attempt();
          if (!target && isUsable(state.lastFocused)) target = state.lastFocused;
          if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
        } catch (e) {}
      }, tries === 0 ? 120 : 200);
    })();
  }

  /* Sekce z odpovědi košíku nasadit TIŠE, bez otevírání drawera: po každém přidání z popupu
     se tím přepočítá počítadlo v hlavičce a obsah drawera je hotový dřív, než se otevře.
     Dělá se to samé co renderContents motivu, jen bez závěrečného open(). */
  function applySectionsQuietly(resp) {
    var c = themeCart();
    if (!c || !resp || !resp.sections || typeof c.getSectionsToRender !== "function") return;
    try {
      c.getSectionsToRender().forEach(function (sec) {
        var host = document.getElementById(sec.id);
        var html = resp.sections[sec.id];
        if (!host || typeof html !== "string") return;
        var parsed = new DOMParser().parseFromString(html, "text/html")
          .querySelector(sec.selector || ".shopify-section");
        if (parsed) host.innerHTML = parsed.innerHTML;
      });
    } catch (e) {}
  }

  /* ================= cart API ================= */
  // Vlastní změny značíme source, ať se hook nezacyklí na pub/sub fallbacku.
  function notifyCart(variantId, cartJson) {
    try {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "nebe-outlet", productVariantId: String(variantId),
          cartData: cartJson, cart: cartJson
        });
      }
    } catch (e) {}
  }

  function withSections(body) {
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(","); body.sections_url = location.pathname; }
    return body;
  }
  function postCart(url, body, cb) {
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(withSections(body))
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; },
                                                function () { return { ok: r.ok, j: null }; }); })
      .then(function (res) { cb(res.ok && res.j && !res.j.status, res.j); })
      .catch(function () { cb(false, null); });
  }

  /* Atribuce stejným způsobem jako shopify-nebe-upsell: skryté line item properties se
     propíšou do objednávky a v Metoriku jdou filtrovat přes meta klíč _upsell_source.
     Klíče držíme shodné napříč elementy, liší se jen hodnota source. */
  function addProps(p, sizeSrc) {
    return {
      _upsell_source: "nebe-outlet",
      _upsell_anchor: (state.anchor && state.anchor.handle) || "",
      _upsell_kind: p.kind === "premium" ? "premium" : "bottom",
      _size_src: sizeSrc
    };
  }

  function cartAdd(variantId, props, cb) {
    busyAdds++;
    postCart(URL_ADD, { items: [{ id: variantId, quantity: 1, properties: props }] }, function (ok, j) {
      busyAdds--;
      if (ok && j) {
        if (j.sections) { state.lastResponse = j; applySectionsQuietly(j); }
        notifyCart(variantId, j);
        var line = (Array.isArray(j.items) && j.items[0]) || null;
        cb(true, line && line.key ? line.key : null, j);
      } else cb(false, null, j);
    });
  }
  function cartRemove(lineKey, cb) {
    busyAdds++;
    postCart(URL_CHANGE, { id: String(lineKey), quantity: 0 }, function (ok, j) {
      busyAdds--;
      if (ok && j) {
        if (j.sections) { state.lastResponse = j; applySectionsQuietly(j); }
        rememberCart(j);
        notifyCart("", j);
      }
      cb(ok, j);
    });
  }

  /* Košík se dotahuje na pozadí a NIKDY se na něj nečeká: rozhodnutí o nabídce je
     synchronní z dat sekce, /cart.js jen zpřesní filtr „už v košíku" a součet pro bar.
     Čekání by popup zdrželo za watchdog a zákaznice by chvíli koukala do prázdna. */
  function refreshCart(cb) {
    fetch(URL_CART_JS, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { rememberCart(c); if (cb) cb(c); })
      .catch(function () { if (cb) cb(null); });
  }

  /* ================= rozhodnutí: co nabídnout ================= */
  function sizeAvail(s) { return !!(s && s.id && (s.qty === true || Number(s.qty) > 0)); }
  function colorHasStock(c) {
    if (!c || !c.sizes) return false;
    for (var k in c.sizes) if (sizeAvail(c.sizes[k])) return true;
    return false;
  }
  function productHasStock(p) {
    return !!(p && Array.isArray(p.colors) && p.colors.some(colorHasStock));
  }

  /* Color-match přes KLÍČ barvy (handle), ne přes přeložený název. Logika zůstává, jen se
     o ní v popupu nemluví: když ladící barva není nebo je v ní vše vyprodané, bereme
     nejprodávanější dostupnou (pořadí v poli colors = pořadí dle prodejnosti).
     Vyprodaná kombinace se nenabídne nikdy. */
  function chooseColor(p, anchorKey) {
    var avail = p.colors.filter(colorHasStock);
    if (!avail.length) return null;
    if (anchorKey) {
      var hit = avail.filter(function (c) { return c.key && c.key === anchorKey; })[0];
      if (hit) return hit;
    }
    return avail[0];
  }

  /* Předvolba velikosti. Když je chtěná vyprodaná, padá se na NEJBLIŽŠÍ dostupnou ve škále;
     při shodné vzdálenosti na obě strany vyhrává větší, protože u prádla je těsné horší
     než volnější a vrací se míň (fit je hlavní páka vratek). */
  function chooseSize(color, braSize) {
    var want = SIZE_MAP[braSize] || braSize;
    if (want && sizeAvail(color.sizes[want])) return { size: want, fallback: false };

    var avail = Object.keys(color.sizes).filter(function (s) { return sizeAvail(color.sizes[s]); });
    if (!avail.length) return { size: null, fallback: false };

    var from = SIZE_SCALE.indexOf(want);
    if (from < 0) return { size: avail[0], fallback: true };   // velikost mimo škálu (např. UNI)

    var best = null, bestD = Infinity;
    avail.forEach(function (s) {
      var i = SIZE_SCALE.indexOf(s);
      if (i < 0) return;
      var d = Math.abs(i - from);
      // < bere bližší; při shodě přebije jen větší velikost, tedy vyšší index
      if (d < bestD || (d === bestD && best !== null && i > SIZE_SCALE.indexOf(best))) { best = s; bestD = d; }
    });
    return { size: best || avail[0], fallback: true };
  }

  /* Nabídka se staví ke kusu, který zákaznice PRÁVĚ přidala, ne k odhadu z košíku.
     Dva spodky a jeden premium kus; co je v košíku nebo vyprodané, se nenabízí. */
  function decideOffer(anchor) {
    if (!anchor) return null;
    function pick(arr, n) {
      return (Array.isArray(arr) ? arr : []).filter(function (p) {
        return p && p.handle && !cartHandles[p.handle] && p.handle !== anchor.handle && productHasStock(p);
      }).slice(0, n);
    }
    var list = pick(D.bottoms, 2).concat(pick(D.premium, 1));
    if (!list.length) return null;
    return { anchorKey: anchor.colorKey, braSize: anchor.size, products: list };
  }

  /* ================= fokus ================= */
  function isUsable(el) {
    return !!(el && el.isConnected && !el.disabled && !el.hidden && el.offsetParent !== null);
  }
  function focusables(root) {
    if (!root) return [];
    return $$('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null; });
  }
  /* Obecná záchrana fokusu. Dialog na několika místech schovává nebo překresluje prvky
     („Přidat" ↔ „Odebrat", swatche po výběru barvy, tlačítka velikostí při změně barvy).
     Kdykoli se to stane prvku, který má zrovna fokus, spadl by fokus na <body>, tedy mimo
     modál. Místo bodového ošetření na každé cestě obalujeme každou takovou změnu tímhle.
     Nečeká se na transitionend: v automatizovaném prohlížeči ani při prefers-reduced-motion
     nedojede a fokus by zůstal viset. */
  function withFocusRescue(mutate, pickTarget) {
    var panel = $("#nouPopPanel", popEl);
    var before = document.activeElement;
    var insidePanel = !!(panel && before && panel.contains(before));
    mutate();
    if (!insidePanel || isUsable(before)) return;
    var target = pickTarget ? pickTarget() : null;
    if (!isUsable(target)) target = focusables(panel)[0];
    if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
  }

  /* ================= povrchy: popup vs. sidecart =================
     Jediné místo, kde se rozhoduje, co je vidět. Popup a drawer nikdy oba naráz: dvě podmínky
     na dvou koncích se v mockupu minuly a popup se dal otevřít nad košíkem. Na ostrém webu
     to spustí cokoli, co sáhne na košík souběžně (blok dárku zdarma, sync z druhé záložky,
     rychlé přidání z dlaždice).

     inert a aria-hidden se nasazují ZÁROVEŇ a jednou funkcí pro OBA povrchy. Fokusovatelný
     obsah uvnitř aria-hidden je porušení WCAG 4.1.2 a u košíku se to rozešlo: visibility
     odchází až po dojetí posunu, takže jeho tlačítka zůstávala 320 ms v tab pořadí. */
  function setSurfaceActive(el, on) {
    if (!el) return;
    try {
      if (on) { el.removeAttribute("inert"); el.setAttribute("aria-hidden", "false"); }
      else { el.setAttribute("inert", ""); el.setAttribute("aria-hidden", "true"); }
    } catch (e) {}
  }

  /* Stránka pod modálním povrchem se odstíní celá, ať se z ní Tab ani odečítač nedostanou
     ven. Jede se po přímých potomcích <body> mimo naše dva kořeny — tím se odstíní i drawer
     motivu, ať sedí kdekoli. Ukládá se, co jsme nasadili my, aby se cizí inert nesundal. */
  /* Cizí souhlasové lišty a dialogy se NEODSTIŇUJÍ.
     Proč: lišta cookie souhlasu na `inert` reagovala tím, že se sama schovala přes
     display:none, a protože display nenastavujeme my, po zavření popupu se už nevrátila.
     Zákaznice pak do konce návštěvy neměla jak souhlas udělit. Je to problém se souhlasem
     se zpracováním údajů, ne s estetikou, takže má přednost před dokonalým odstíněním.
     Past na fokus tím netrpí: Tab drží uvnitř panelu vlastní obsluha v bind(), která ho
     při každém úniku vrátí zpátky, ne `inert`. Ten je jen druhá vrstva.
     Poznávají se podle role dialogu nebo podle jména, a to napříč dodavateli, ne natvrdo
     podle jedné třídy jedné aplikace. Falešně pozitivní shoda je levná: prvek se jen
     neodstíní a past na fokus platí dál. */
  /* Jména se kryjí s tím, co obchod opravdu používá (aplikace Pandectes GDPR Cookie Consent:
     obal `id="pandectes-banner" class="cc-window-wrapper cc-popup-wrapper"`, uvnitř
     `pd-cookie-banner-window cc-window`, popisek `cookieconsent:desc`), a k tomu s běžnými
     dodavateli. Zkratkové varianty `cc-window` / `cc-popup` / `cc-banner` jsou tu schválně:
     samotné „cc-" nestačí, protože se objevuje i jinde (ikony karet a podobně). */
  var CONSENT_RE = /(consent|cookieconsent|cookie|gdpr|ccpa|privacy|souhlas|\bcmp\b|pandectes|pd-cookie|cc-window|cc-popup|cc-banner|onetrust|cookiebot|klaro|osano|termly|shopify-pc|cky[-_])/i;
  var DIALOG_SEL = '[aria-modal="true"],[role="dialog"],[role="alertdialog"]';
  var CONSENT_SEL = '[id*="consent" i],[class*="consent" i],[id*="cookie" i],[class*="cookie" i],' +
    '[id*="pandectes" i],[class*="pandectes" i],[class*="cc-window" i],[class*="cc-banner" i],' +
    '[class*="cc-popup" i],[id*="gdpr" i],[class*="gdpr" i]';
  var LANDMARK_SEL = 'main,header,footer,#MainContent,[role="main"],[role="banner"],[role="contentinfo"]';

  /* Obsah stránky se nevyjímá NIKDY, ani když v sobě má prvek s rolí dialogu. Motiv jich
     má několik schovaných uvnitř obsahu (quick-view v card-product.liquid, zvětšenina fotky,
     vyhledávání), takže hledat roli dialogu mezi potomky by z odstínění vyhodilo rovnou
     celý #MainContent i hlavičku. Hledá se proto jen po jménu, a jen v obalech,
     ve kterých žádný landmark není, tedy typicky v blocích, které si tam vloží appka. */
  function isLandmark(el) {
    try {
      if (el.matches && el.matches(LANDMARK_SEL)) return true;
      if (el.querySelector && el.querySelector('main,#MainContent,[role="main"]')) return true;
    } catch (e) {}
    return false;
  }
  function isOwnSurface(el) {
    try {
      /* Landmark se testuje PRVNÍ a je nepřekročitelný: obsah stránky, hlavička ani patička
         nejsou nikdy cizí souhlasová lišta, ať mají v třídách cokoli. Díky tomu si můžeme
         u jmen dovolit být štědří, aniž bychom riskovali, že se kvůli náhodné shodě
         v nějaké třídě přestane odstiňovat půlka webu. */
      if (isLandmark(el)) return false;
      if (el.matches && el.matches(DIALOG_SEL)) return true;                 // sám je dialog
      if (CONSENT_RE.test((el.id || "") + " " + (el.getAttribute("class") || ""))) return true;
      // některé appky věší jméno až na vnitřní obal, ne na svůj kořen v <body>
      if (el.querySelector && el.querySelector(CONSENT_SEL)) return true;
    } catch (e) {}
    return false;
  }

  /* SLEDOVÁNÍ A ODSTÍNĚNÍ JSOU DVĚ NEZÁVISLÉ VĚCI. Tohle je jádro opravy nálezu L1:
     první pokus navázal vracení `display` na seznam odstíněných prvků, takže ve chvíli, kdy
     jsme cookie lištu z odstínění vyjmuli, vypadla zároveň ze sledování a nikdo jí stav
     nevracel. Před opravou se odstiňovala a nevracela, po opravě se neodstiňovala a nevracela
     taky. Proto se teď sleduje KAŽDÝ přímý potomek body, i ten, který vědomě neodstiňujeme.
     Díky tomu je oprava nezávislá na příčině mizení: ať se aplikace schová kvůli čemukoli,
     po zavření popupu jí vrátíme stav, jaký měla před ním. */
  var watched = [];
  var inertGuard = null;

  function visible(el) {
    try { return window.getComputedStyle(el).display !== "none"; } catch (e) { return true; }
  }

  function setPageInert(on) {
    try {
      if (on) {
        if (watched.length) return;
        Array.prototype.forEach.call(document.body.children, function (el) {
          if (el === popEl || el === toastEl) return;
          if (el.tagName === "SCRIPT" || el.tagName === "STYLE" || el.tagName === "LINK") return;
          // Zaznamená se VŽDY: inline display, vypočtený display a to, jestli byl prvek vidět.
          var rec = { el: el, dsp: el.style.display, shown: visible(el),
            cdsp: "", aria: null, inerted: false };
          try { rec.cdsp = window.getComputedStyle(el).display; } catch (e) {}
          // Odstiňuje se jen to, co odstínit smíme a potřebujeme.
          if (!el.hasAttribute("inert") && !isOwnSurface(el)) {
            rec.aria = el.getAttribute("aria-hidden");
            rec.inerted = true;
            el.setAttribute("inert", "");
            el.setAttribute("aria-hidden", "true");
          }
          watched.push(rec);
        });
        // Pojistka proti odstíněné stránce, kdyby se zavírací cesta z jakéhokoli důvodu
        // nedoběhla: po 20 s zkontroluj, jestli popup vůbec ještě visí, a když ne, uklid.
        clearTimeout(inertGuard);
        inertGuard = setTimeout(function () { if (!isPopupOpen()) setPageInert(false); }, 20000);
      } else {
        clearTimeout(inertGuard);
        watched.forEach(function (rec) {
          try {
            if (rec.inerted) {
              rec.el.removeAttribute("inert");
              if (rec.aria === null) rec.el.removeAttribute("aria-hidden");
              else rec.el.setAttribute("aria-hidden", rec.aria);
            }
            unhide(rec);
          } catch (e) {}
        });
        watched = [];
      }
    } catch (e) { watched = []; }
  }

  /* Vrácení viditelnosti prvku, který se během otevřeného popupu sám schoval.
     Dva kroky, protože schovat se dá dvěma způsoby a my nevíme, který aplikace použije:
       1) inline display:none → stačí vrátit původní inline hodnotu,
       2) schování přes třídu → inline hodnotu nemá cenu mazat, musíme přebít tím,
          co měl prvek vypočteno předtím (typicky „flex" u lišty souhlasu).
     Krok 2 nechává na prvku náš inline styl, který by appce bránil schovat lištu ve chvíli,
     kdy zákaznice souhlas opravdu udělí. Proto se náš zásah sám zruší při prvním dotyku
     prvku: appka pak lištu schová svou vlastní cestou a my jí v tom nestojíme. */
  /* Prvek se smí vrátit jen tehdy, když po vrácení bude doopravdy VIDĚT. Kdyby se ukázalo,
     že ho aplikace kromě display schovala i jinak (průhlednost, nulový rozměr), nechá se
     schovaný: odkrytý průhledný prvek přes celou šířku by z něj udělal past na kliky,
     tedy něco horšího než schovaná lišta.
     Přesně tenhle případ nastává u lišty Pandectes, která při zavření nechává třídu
     `cc-invisible` s `opacity: 0` a k tomu inline `display: none`. */
  function reallyVisible(el) {
    try {
      if (!visible(el)) return false;
      var cs = window.getComputedStyle(el);
      if (parseFloat(cs.opacity) === 0 || cs.visibility === "hidden") return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    } catch (e) { return false; }
  }

  function unhide(rec) {
    var el = rec.el;
    if (!rec.shown) return;        // schovaný byl už před popupem, do toho nám nic není
    if (visible(el)) return;       // nezmizel, není co vracet
    var before = el.style.display;

    // 1) inline schování → stačí vrátit původní inline hodnotu
    if (el.style.display === "none" && rec.dsp !== "none") el.style.display = rec.dsp;
    // 2) schování přes třídu → přebít tím, co měl prvek vypočteno předtím
    if (!visible(el)) el.style.setProperty("display", (rec.cdsp && rec.cdsp !== "none") ? rec.cdsp : "block");

    if (!reallyVisible(el)) { el.style.display = before; return; }   // nepomohlo, nešpiníme
    if (el.style.display === before) return;                        // nic jsme nezměnili

    /* Náš inline styl by appce bránil lištu schovat ve chvíli, kdy zákaznice souhlas udělí.
       Proto se sám zruší při prvním dotyku prvku. */
    var undo = function () {
      try { el.style.display = before; } catch (e) {}
      el.removeEventListener("pointerdown", undo, true);
      el.removeEventListener("click", undo, true);
    };
    el.addEventListener("pointerdown", undo, true);
    el.addEventListener("click", undo, true);
  }

  var scrollLocked = false;
  function setScrollLock(on) {
    try {
      if (on === scrollLocked) return;
      scrollLocked = on;
      document.documentElement.style.overflow = on ? "hidden" : "";
      document.body.style.overflow = on ? "hidden" : "";
    } catch (e) {}
  }

  var armT = null;
  function showPopup(on) {
    if (!popEl) return;
    if (on) {
      /* Drawer motivu, kdyby visel nebo se právě otevíral (rychlé přidání z dlaždice,
         pub/sub fallback, blok dárku zdarma), zavíráme jeho VLASTNÍM API, nikdy skrýváním.
         Třikrát proto, že motiv drawer otevírá řetězem setTimeoutů a v nehookované variantě
         až po publish, takže jedno zavolání by minulo. Dál to hlídá suppressDrawer(). */
      closeThemeCart();
      requestAnimationFrame(closeThemeCart);
      setTimeout(closeThemeCart, 60);

      popEl.hidden = false;
      applyView();
      setSurfaceActive(popEl, true);
      setPageInert(true);
      setScrollLock(true);
      /* 500 ms hluchota pozadí: druhý klik z dvojkliku na „Přidat do košíku" nesmí popup
         zavřít dřív, než ho zákaznice vůbec uvidí. 500 ms proto, že tolik je systémový práh
         dvojkliku na macOS, kratší okno část dvojkliků pustí. */
      popEl.classList.add("nou-armed");
      clearTimeout(armT);
      armT = setTimeout(function () { popEl.classList.remove("nou-armed"); }, 500);
    } else {
      clearTimeout(armT);
      popEl.classList.remove("nou-armed");
      setSurfaceActive(popEl, false);
      popEl.hidden = true;
      setPageInert(false);
      setScrollLock(false);
    }
  }

  /* ================= popup ================= */
  function plural(n) {
    var one = Tplain("itemOne"), few = Tplain("itemFew"), many = Tplain("itemMany");
    return n === 1 ? one : (n >= 2 && n <= 4 ? (few || many) : (many || few));
  }

  // Primární CTA se objeví teprve tehdy, když si něco přidá, a říká, co se STALO.
  // Přidání je okamžité, takže „Přidat 2 položky" by slibovalo přidání podruhé.
  // Dokud si nic nepřidá, je dole jediná akce: odmítnutí.
  function syncGoBtn() {
    var btn = $("#nouGo", popEl);
    if (!btn) return;
    var n = isPopupOpen() ? cardRegistry.filter(function (c) { return c.isAdded(); }).length : 0;
    var txt = n ? T("doneCta", { n: digits(n), slovo: esc(plural(n)) }) : "";
    var on = !!(n && txt);
    var skip = $("#nouSkip", popEl);
    var foot = btn.parentNode;

    /* V patičce je VŽDY jen jedna akce.
       Dokud si zákaznice nic nepřidá, je to odmítnutí. Jakmile si něco přidá, odmítnutí
       zmizí a zůstane žluté CTA přes celou šířku: obě tlačítka dělají fakticky totéž
       (zavřít popup a vysunout košík), takže vedle sebe jen nutí vybírat mezi dvěma
       stejnými cestami. Přepíná se to oběma směry — po odebrání posledního kusu se
       odmítnutí vrátí.
       Celá výměna je v obalovači záchrany fokusu: mizí tu prvek v patičce, ne v kartě,
       takže když zrovna drží fokus, musí ho převzít tlačítko, které zůstává. */
    withFocusRescue(function () {
      btn.hidden = !on;
      btn.innerHTML = on ? txt : "";
      // odmítnutí se vrací jen tehdy, když vůbec má co zobrazit (text z locales)
      if (skip) skip.hidden = on || !skip.textContent;
      if (foot && foot.classList) foot.classList.toggle("nou-has-cta", on);
    }, function () { return on ? btn : skip; });
  }

  function renderShip(box, msg, fill, sum) {
    var pct = THRESH ? Math.max(0, Math.min(100, Math.round((sum / THRESH) * 100))) : 100;
    if (fill) fill.style.transform = "scaleX(" + (pct / 100) + ")";
    if (sum >= THRESH) {
      box.classList.add("is-done");
      msg.innerHTML = T("shipDone");
    } else {
      box.classList.remove("is-done");
      var left = money(THRESH - sum);
      if (!left) { box.hidden = true; return; }
      msg.innerHTML = T("shipRemaining", { x: "<b>" + digits(left) + "</b>" });
    }
  }

  /* Bar dopravy zdarma má smysl jen když je práh z nabídky reálně dosažitelný; jinak jen
     demotivuje. Dosažitelnost se počítá z toho, co ZBÝVÁ přidat, ne ze všeho nabízeného,
     jinak bar visí i po přidání všech tří kusů a hlásí chybějící stovky, které už nemá čím
     doplnit. Při vypnutém baru se nepočítá a nehlásí vůbec nic. */
  function syncPopupShip(pulse) {
    var box = $("#nouPopShip", popEl);
    if (!box) return;
    if (!shipBarOn() || !state.offered || !has("shipRemaining") || !has("shipDone")) { box.hidden = true; return; }
    var left = cardRegistry.length
      ? cardRegistry.reduce(function (s, c) { return s + (c.isAdded() ? 0 : (c.price || 0)); }, 0)
      : state.offered.products.reduce(function (s, p) { return s + (Number(p.price) || 0); }, 0);
    if (state.cartTotal + left < THRESH) { box.hidden = true; return; }
    box.hidden = false;
    renderShip(box, $("#nouPopShipMsg", popEl), $("#nouPopShipFill", popEl), state.cartTotal);
    if (pulse && !box.hidden) { box.classList.remove("nou-pulse"); void box.offsetWidth; box.classList.add("nou-pulse"); }
  }

  // Po každé změně košíku se překreslí všechno, co o něm něco tvrdí — a v tomhle pořadí:
  // karty první, protože počet v CTA se čte z nich a jinak by kulhal o krok pozadu.
  function cartChanged(pulse) {
    cardRegistry.forEach(function (c) { c.sync(); });
    syncGoBtn();
    syncPopupShip(pulse);
  }

  // Žije ještě kus, který popup spustil? Velikostní hint mluví o JEHO velikosti, takže
  // s ním musí zmlknout. Během popupu je drawer zavřený, takže kotva zmizet skoro nemůže —
  // ale cizí zásah do košíku (druhá záložka, app) to udělat dokáže.
  function anchorAlive() { return !state.anchorGone; }

  function buildCard(p, offer) {
    var picked = chooseColor(p, offer.anchorKey);
    // auto = velikost předvybral popup (ne zákaznice), fallback = musela ustoupit z vyprodané
    var sel = { color: picked, size: null, auto: false, fallback: false,
      lostSize: null, added: false, lineKey: null };

    var card = document.createElement("div");
    card.className = "nou-card" + (p.kind === "premium" ? " nou-card--premium" : "");
    card.innerHTML =
      '<div class="nou-card__img">' +
        (p.kind === "premium" && has("premiumFlag")
          // T() už je sanitizované, druhé escapování by ze zvýraznění udělalo text
          ? '<span class="nou-card__pflag">' + T("premiumFlag") + "</span>" : "") +
        // src se dosazuje v renderColor(); průhledný placeholder drží šablonu odolnou,
        // ať se pořadí volání změní jakkoli, a nikdy tu není rozbitý rámeček
        '<img src="' + BLANK_PX + '" alt="" loading="lazy" decoding="async">' +
      "</div>" +
      '<div class="nou-card__body">' +
        '<div class="nou-card__head">' +
          '<span class="nou-card__title"></span>' +
          '<span class="nou-card__price"></span>' +
        "</div>" +
        '<div class="nou-card__rating"></div>' +
        /* Pořadí je shodné s ostrým produktovým detailem (nebe-pdp.liquid:766-777):
           barva → swatche → velikosti → vysvětlivka → tlačítko. Barva je nadřazená volba,
           protože dostupnost velikostí závisí na ní, ne naopak; opačné pořadí navádělo
           vybrat velikost, kterou pak změna barvy mohla vzít.
           Vysvětlivka zůstává U VELIKOSTÍ, mluví o nich. */
        '<p class="nou-card__cname"></p>' +
        '<div class="nou-card__swatches" role="group"></div>' +
        '<div class="nou-card__sizes" role="group"></div>' +
        '<p class="nou-card__hint"></p>' +
        '<button type="button" class="nou-card__add"></button>' +
        '<div class="nou-card__added" hidden>' +
          '<span class="nou-card__ok"></span>' +
          '<button type="button" class="nou-card__undo"></button>' +
        "</div>" +
      "</div>";

    var img = $(".nou-card__img img", card);
    var titleEl = $(".nou-card__title", card);
    var priceEl = $(".nou-card__price", card);
    var sizesWrap = $(".nou-card__sizes", card);
    var hintEl = $(".nou-card__hint", card);
    var cname = $(".nou-card__cname", card);
    var swWrap = $(".nou-card__swatches", card);
    var addBtn = $(".nou-card__add", card);
    var addedBox = $(".nou-card__added", card);
    var okEl = $(".nou-card__ok", card);
    var undoBtn = $(".nou-card__undo", card);

    // Název je odkaz na produkt jen tehdy, když sekce dodala URL: rozmyšlené prokliknutí
    // z popupu je legitimní cesta ven a zákaznice ji nesmí hledat.
    if (p.url) {
      var a = document.createElement("a");
      a.href = p.url; a.className = "nou-card__link"; a.textContent = p.title || "";
      titleEl.appendChild(a);
    } else titleEl.textContent = p.title || "";

    addBtn.textContent = Tplain("cardAdd");
    okEl.textContent = Tplain("cardAdded");
    undoBtn.textContent = Tplain("cardUndo");
    if (has("sizeGroup")) sizesWrap.setAttribute("aria-label", Tplain("sizeGroup"));
    if (has("colorGroup")) swWrap.setAttribute("aria-label", Tplain("colorGroup"));

    // cena: hotové řetězce ze sekce, nikdy skládané v JS (na eurovém trhu je měna jiná)
    priceEl.innerHTML =
      (p.compareAtFormatted && Number(p.compareAt) > Number(p.price)
        ? "<s>" + digits(p.compareAtFormatted) + "</s>" : "") +
      digits(p.priceFormatted || "");

    // hodnocení: zlatý overlay dle průměru; hvězdy jsou dekorace, číslo vedle nich nese význam
    if (p.rating && Number(p.rating.value)) {
      var val = Number(p.rating.value);
      var pct = Math.max(0, Math.min(100, Math.round((val / 5) * 100)));
      var rEl = $(".nou-card__rating", card);
      /* Počet hodnocení se ZÁMĚRNĚ nevykresluje, v kartě zůstávají jen hvězdy a průměr.
         `rating.count` z Liquidu chodí dál a nesahá se na něj: je to rozhodnutí o zobrazení,
         ne o datovém kontraktu, takže vrácení počtu je změna jednoho řádku tady. */
      rEl.innerHTML = '<span class="nou-stars" aria-hidden="true"><i style="width:' + pct +
        '%">★★★★★</i>★★★★★</span><b>' + digits(val.toFixed(1).replace(".", ",")) + "</b>";
      /* Do popisku pro odečítač se předává i count, přestože ho dnešní znění nepoužívá:
         kdyby ho locales v textu měly, vyplní se místo toho, aby ve větě zůstal viset
         nevyplněný zástupný symbol. Prázdná závorka ani nula tam vzniknout nemůžou,
         protože popisek skládají locales, ne tenhle kód. */
      if (has("ratingAria")) rEl.setAttribute("aria-label",
        Tplain("ratingAria", { value: val.toFixed(1), count: p.rating.count || "" }));
    }

    function renderSizes() {
      sizesWrap.innerHTML = "";
      var sizes = (sel.color && sel.color.sizes) || {};
      Object.keys(sizes).forEach(function (sz) {
        var avail = sizeAvail(sizes[sz]);
        var b = document.createElement("button");
        b.type = "button";
        b.className = "nou-size" + (avail ? "" : " is-oos");
        b.dataset.size = sz;
        b.textContent = sz;
        b.disabled = !avail || sel.added;   // vyprodané nejde vybrat, přidaná karta se nemění
        b.setAttribute("aria-pressed", String(sz === sel.size));
        var lab = avail ? Tplain("sizeAria", { size: sz }) : Tplain("sizeAriaOos", { size: sz });
        if (lab) b.setAttribute("aria-label", lab);
        b.addEventListener("click", function () {
          sel.size = sz;
          sel.auto = false; sel.fallback = false; sel.lostSize = null;   // vlastní volba se nekomentuje
          sizesWrap.classList.remove("nou-needs");
          $$(".nou-size", sizesWrap).forEach(function (el) {
            el.setAttribute("aria-pressed", String(el.dataset.size === sz));
          });
          renderHint();
        });
        sizesWrap.appendChild(b);
      });
    }

    /* Fit je hlavní páka vratek, takže věta o velikosti je složená ze dvou částí, které
       platí nezávisle na sobě, a každá má vlastní podmínku:
         STAV: „velikost M je v téhle barvě vyprodaná" se řídí SKLADEM ve zvolené barvě
               a platí bez ohledu na to, kdo velikost vybral. Mizí, až když je skladem.
         VOLBA: „vybrali jsme nejbližší L, klidně změň" se řídí tím, že vybíral popup
               (sel.auto), a mizí, jakmile velikost vybere zákaznice sama.
       Dřív mizelo obojí najednou a s naší volbou se ztrácela i pravdivá informace o skladu.
       Celý hint ztichne, když kotva z košíku zmizí, protože mluví o JEJÍ velikosti;
       tuhle podmínku neměnit, vrátila by se tím chyba z třetího kola QA. */
    function renderHint() {
      if (!anchorAlive() || !sel.color) { hintEl.innerHTML = ""; return; }
      var want = SIZE_MAP[offer.braSize] || offer.braSize;
      var wantSoldOut = !!(want && !sizeAvail(sel.color.sizes[want]));
      var parts = [];

      // Stavová půlka mluví o velikosti, která tady chybí. Když zákaznici po změně barvy
      // zmizela JEJÍ volba, je to ta její: jinak by se nikde nedozvěděla, proč předvolba
      // zmizela, a dostala by jen pobídku „nejdřív vyber velikost" až u přidání do košíku.
      var lost = (sel.lostSize && !sizeAvail(sel.color.sizes[sel.lostSize])) ? sel.lostSize : null;
      var stateSize = lost || (wantSoldOut ? want : null);
      if (stateSize) parts.push(T("sizeSoldOutState", { size: esc(stateSize) }));

      // Věta o naší volbě mluví o velikosti nahoře, takže bez ní nedává smysl: u kusu bez
      // velikostní volby (jedna velikost, UNI) se vynechá celá, ne aby zbyla prázdná <b>.
      if (sel.auto && sel.size && offer.braSize && sel.size !== offer.braSize) {
        parts.push(wantSoldOut
          ? T("sizeNearestPicked", { size: esc(sel.size) })
          // posun podle sizeMap; u premium kusu (tílko/crop top) nemluv o „dole"
          : T(p.kind === "premium" ? "sizeHintPremium" : "sizeHint",
              { bra: esc(offer.braSize || ""), size: esc(sel.size) }));
      }
      hintEl.innerHTML = parts.filter(Boolean).join(" ");
    }

    /* Název barvy ve stejném tvaru jako na produktovém detailu (renderColorName
       v nebe-pdp.js:635-638): tučný název, za ním ztlumený podtitul za oddělovačem.
       Prefix („Barva:") si nese samotný text z locales, takže se dá vypnout výměnou
       jednoho řetězce, aniž by se sahalo do kódu. */
    function renderColorLabel() {
      if (!sel.color) { cname.innerHTML = ""; return; }
      var nm = colorName(sel.color);
      var html = T("colorLabel", { name: esc(nm) }) || "<b>" + esc(nm) + "</b>";
      if (sel.color.sub) html += ' <span>\u00b7 ' + esc(sel.color.sub) + "</span>";
      cname.innerHTML = html;
    }

    function renderColor(keepSize) {
      if (!sel.color) return;
      if (img) {
        /* Fotka JEN ze zvolené barvy. ŽÁDNÁ ZÁLOŽNÍ CESTA — tenhle řádek dřív zněl
           `sel.color.img || p.img || ""` a to je past, kterou sem prosím nevracet:
           barva bez vlastní fotky by spadla na fotku produktu, tedy na CIZÍ BARVU, a to
           přesně ve chvíli, kdy se zákaznice o barvě rozhoduje. Liquid tuhle záložní cestu
           odstranil u zdroje (dusk/bílá ukazovala hnědou, stellar/bílá černou) a posílá
           `img: null`; kdyby ji tady držel JS, vypadala by jeho oprava hotově a dole by se
           tiše obcházela, přičemž obě části by samy o sobě vypadaly správně.
           `img: null` proto znamená kartu bez fotky: tichá prázdná plocha v poměru stran. */
        var src = sel.color.img || "";
        img.src = src || BLANK_PX;          // nikdy bez src, viz BLANK_PX
        img.style.display = src ? "" : "none";
        /* Ohnisko je POVINNÉ, ne volitelné: každá barva má vlastní fotku i vlastní ohnisko
           a bez něj se u produktových fotek ořízne to podstatné (u tílka celá postava,
           u tang jen střed těla, tedy pokaždé jinak). Nastavuje se tady, uvnitř výměny
           fotky, takže se nemůže stát, že se vymění obrázek a zůstane ohnisko předchozí barvy.
           Chybějící ohnisko padá VĚDOMĚ na „center 38%", ne na výchozí „50% 50%" prohlížeče:
           u postavy na výšku sedí těžiště nad polovinou, takže se stejná fotka ořízne stejně
           bez ohledu na to, jestli má někdo ohnisko vyplněné v administraci. */
        img.style.objectPosition = sel.color.fp || "center 38%";
        img.alt = (p.title || "") + " " + colorName(sel.color);
      }
      renderColorLabel();
      $$(".nou-swatch", swWrap).forEach(function (el) {
        el.setAttribute("aria-pressed", String(el.dataset.ckey === sel.color.key));
      });

      /* Velikost je rozhodnutí vázané na ZVOLENOU BARVU, ne na košík. Vlastní volba zákaznice
         se do nové barvy přenáší, dokud je tam skladem. Volbu, kterou udělal popup, naopak
         pro novou barvu přepočítáme: když je v ní chtěná velikost skladem, ústup už nemá
         důvod, vrátíme se na ni a hint zmizí; když není, ustoupíme znovu. Bez toho visela
         věta „velikost M je vyprodaná" nad nepřeškrtnutým klikatelným M. */
      if (keepSize && !sel.auto) {
        if (sel.size && sizeAvail(sel.color.sizes[sel.size])) {
          // její volba je i v nové barvě skladem, nesaháme na ni
        } else if (sel.lostSize && sizeAvail(sel.color.sizes[sel.lostSize])) {
          // vrátila se do barvy, kde její původní volba zase je: vrátit JEJÍ velikost není
          // odhad, je to respekt k tomu, co si vybrala
          sel.size = sel.lostSize; sel.lostSize = null; sel.fallback = false;
        } else {
          // její velikost tu není: zapamatuj si ji, ať se dá říct, proč předvolba zmizela.
          // Pamatuje se vždy jen jedna, poslední vlastní volba.
          sel.lostSize = sel.size || sel.lostSize;
          sel.size = null; sel.fallback = false;
        }
      } else {
        var pickedSize = chooseSize(sel.color, offer.braSize);
        sel.size = pickedSize.size;
        sel.auto = !!pickedSize.size;
        sel.fallback = !!pickedSize.fallback;
        sel.lostSize = null;
      }
      renderSizes();
      renderHint();
    }

    /* Barevná kolečka jsou vidět rovnou, bez rozklikávání, stejně jako na produktovém
       detailu. Vyprodaná barva se NEVYNECHÁVÁ: ukáže se ztlumená a přeškrtnutá, ale nejde
       vybrat, protože zákaznice potřebuje vidět, že ta barva existuje a proč ji nemá.
       Předvolbu i tak dál vybírá chooseColor jen z dostupných. */
    p.colors.forEach(function (c) {
      var avail = colorHasStock(c);
      var b = document.createElement("button");
      b.type = "button";
      b.className = "nou-swatch" + (avail ? "" : " is-oos");
      b.dataset.ckey = c.key || "";
      b.disabled = !avail;
      var nm = colorName(c);
      b.title = colorFullName(c) || nm;
      var lab = (!avail && has("colorAriaOos"))
        ? Tplain("colorAriaOos", { name: nm })
        : Tplain("colorAria", { name: nm });
      if (lab) b.setAttribute("aria-label", lab);
      b.setAttribute("aria-pressed", "false");
      b.innerHTML = '<i style="background:' + esc(c.swatch || "#ddd") + '"></i>';
      if (avail) b.addEventListener("click", function () {
        if (sel.added) return;              // přidaný kus se už nepřebarvuje
        // Kolečka se po výběru nesbalují, takže fokus zůstává na zvolené barvě.
        withFocusRescue(function () { sel.color = c; renderColor(true); }, function () { return b; });
      });
      swWrap.appendChild(b);
    });

    function setAdded(on) {
      withFocusRescue(function () {
        sel.added = on;
        card.classList.toggle("is-added", on);
        addBtn.hidden = on;
        addedBox.hidden = !on;
        // barvy se zamykají stejně jako velikosti: přidaný kus se už nepřebarvuje
        $$(".nou-swatch", swWrap).forEach(function (el) {
          if (!el.classList.contains("is-oos")) el.disabled = on;
        });
        renderSizes();
      }, function () { return on ? undoBtn : addBtn; });   // protějšek na téže kartě
    }

    /* Přidání = 1 klik, okamžitě. Během letu požadavku se tlačítko NEDISABLUJE: disabled
       prvek přijde o fokus a klávesnice by skončila na <body>. Drží se jen příznakem
       a aria-disabled, takže dvojklik neprojde a fokus zůstane, kde byl. */
    var pending = false;
    function setPending(btn, on) {
      pending = on;
      card.classList.toggle("is-busy", on);
      if (on) btn.setAttribute("aria-disabled", "true"); else btn.removeAttribute("aria-disabled");
    }
    addBtn.addEventListener("click", function () {
      if (sel.added || pending) return;
      if (!sel.size) {
        toast(Tplain("toastPickSize"));
        sizesWrap.classList.add("nou-needs");
        sizesWrap.classList.remove("nou-shake"); void sizesWrap.offsetWidth;
        sizesWrap.classList.add("nou-shake");
        return;
      }
      var slot = sel.color.sizes[sel.size];
      if (!sizeAvail(slot)) { toast(Tplain("toastAddError")); renderSizes(); return; }

      setPending(addBtn, true);
      var sizeSrc = sel.auto ? (sel.fallback ? "fallback" : "auto") : "manual";
      cartAdd(slot.id, addProps(p, sizeSrc), function (ok, lineKey, json) {
        setPending(addBtn, false);
        if (!ok) {
          // doprodáno mezi vykreslením a kliknutím: hlášku dodá Shopify, když ji sekce nemá
          var msg = Tplain("toastAddError") ||
            (json && (json.description || json.message)) || "";
          toast(msg);
          return;
        }
        sel.lineKey = lineKey;
        if (p.handle) cartHandles[p.handle] = true;
        state.cartTotal += (Number(p.price) || 0);
        setAdded(true);
        cartChanged(true);
        track("add", { handle: p.handle, kind: p.kind, size: sel.size, color: sel.color.key, sizeSrc: sizeSrc });
        log("přidáno: " + p.title + " · " + (sel.color.key || "") + " · " + sel.size);
      });
    });

    undoBtn.addEventListener("click", function () {
      if (pending) return;
      if (!sel.lineKey) { setAdded(false); cartChanged(true); return; }
      setPending(undoBtn, true);
      cartRemove(sel.lineKey, function (ok) {
        setPending(undoBtn, false);
        if (!ok) { toast(Tplain("toastAddError")); return; }
        if (p.handle) delete cartHandles[p.handle];
        sel.lineKey = null;
        // součet ani cartHandles se tu nepřepočítávají ručně: cartRemove dostal celý košík
        // a rememberCart() ho už srovnal podle serveru
        setAdded(false);
        cartChanged(true);
      });
    });

    /* Stav karty se odvozuje z košíku, ne z paměti karty: když řádek z košíku zmizí cizím
       zásahem, karta by jinak visela v „✓ Přidáno" a kus by už nešel přidat znovu. */
    cardRegistry.push({
      price: Number(p.price) || 0,
      isAdded: function () { return sel.added; },
      lineKey: function () { return sel.lineKey; },
      dropped: function () { sel.lineKey = null; if (sel.added) setAdded(false); },
      sync: function () { renderHint(); }
    });

    renderColor(false);
    return card;
  }

  function renderPopup(offer) {
    state.offered = offer;

    var thanks = $("#nouThanks", popEl), title = $("#nouPopTitle", popEl), proof = $("#nouProof", popEl);
    thanks.textContent = Tplain("popThanks"); thanks.hidden = !thanks.textContent;
    title.textContent = Tplain("popTitle");
    var setCount = D.proof && D.proof.setCount;
    var proofTxt = setCount ? T("popProof", { count: digits(esc(String(setCount))) }) : "";
    proof.innerHTML = proofTxt;
    proof.hidden = !proofTxt;

    var skip = $("#nouSkip", popEl);
    skip.textContent = Tplain("skipNothing");
    skip.hidden = !skip.textContent;

    var wrap = $("#nouCards", popEl);
    wrap.innerHTML = "";
    cardRegistry = [];                    // karty minulého popupu už neexistují
    offer.products.forEach(function (p) {
      try { wrap.appendChild(buildCard(p, offer)); }
      catch (e) { log("karta se nepovedla, přeskakuji: " + (e && e.message)); }
    });
    if (!wrap.children.length) throw new Error("žádná karta se nevykreslila");
    /* data-count řídí mřížku (3 sloupce / 2 vystředěné / 1 vystředěná), takže musí sedět na
       to, co se OPRAVDU vykreslilo, ne na to, co se nabízelo. Kdyby karta neprošla, zůstalo
       by po ní v mřížce prázdné místo. */
    wrap.setAttribute("data-count", wrap.children.length);

    syncGoBtn();
    syncPopupShip(false);

    showPopup(true);
    var panel = $("#nouPopPanel", popEl);
    if (panel) panel.scrollTop = 0;
    // preventScroll: bez toho prohlížeč odroluje panel na tlačítko v patičce a hlavička zmizí
    var first = (skip && !skip.hidden) ? skip : ($("#nouPopX", popEl) || focusables(panel)[0]);
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }

  /* ================= cesty ven ================= */
  /* Každá cesta z popupu ven končí v otevřeném sidecartu: křížek, Esc, klik mimo, odmítnutí
     i CTA. Popup se zavírá vždy dřív, než se drawer otevře — nikdy oba naráz. */
  function closePopup(reason) {
    try {
      track("dismiss", {
        reason: reason || "",
        added: cardRegistry.filter(function (c) { return c.isAdded(); }).length
      });
    } catch (e) {}
    try { showPopup(false); } catch (e) {}
    state.offered = null;
    cardRegistry = [];
    // Když ještě běží přidávání, dej mu chvíli doběhnout, ať drawer ukáže i poslední kus.
    if (busyAdds > 0) {
      var waited = 0;
      var tick = setInterval(function () {
        waited += 80;
        if (busyAdds <= 0 || waited >= 1200) { clearInterval(tick); openThemeCart(reason || "zavřen popup"); }
      }, 80);
      return;
    }
    openThemeCart(reason || "zavřen popup");
  }

  /* ================= trigger + 4 pojistky ================= */
  function itemOf(resp, variantId) {
    if (!resp) return null;
    if (Array.isArray(resp.items) && resp.items.length) {
      var hit = resp.items.filter(function (i) {
        return String(i.variant_id || i.id) === String(variantId);
      })[0];
      return hit || resp.items[0];
    }
    if (resp.id || resp.variant_id) return resp;
    return null;
  }
  /* Outlet se pozná podle product_type PRÁVĚ PŘIDANÉHO kusu, ne podle obsahu košíku:
     v košíku můžou ležet outletové kusy z dřívějška a popup se váže na tenhle jeden přídavek.
     Typ se porovnává proti nastavení sekce, tolerantně k mezerám i velikosti písmen. */
  function isOutlet(item) {
    return !!item && String(item.product_type || "").trim().toUpperCase() === OUTLET_TYPE;
  }
  /* Barva a velikost přidaného kusu z voleb varianty. Velikost se pozná podle toho, že je
     klíčem v sizeMap nebo prvkem škály — to je jazykově nezávislé a nezlomí se na tom, že
     jeden produkt má volbu „Velikost" a druhý „Size". Barva je ta druhá volba; páruje se
     přes handle, ne přes přeložený řetězec. */
  function optionsOf(item) {
    var out = { colorValue: "", size: "" };
    var ov = item && item.options_with_values;
    if (!Array.isArray(ov) || !ov.length) return out;
    var rest = [];
    ov.forEach(function (o) {
      var v = o && o.value != null ? String(o.value) : "";
      if (!v) return;
      if (!out.size && (SIZE_MAP[v] || SIZE_SCALE.indexOf(v) >= 0)) out.size = v;
      else rest.push(v);
    });
    if (!out.size && rest.length > 1) out.size = rest.pop();   // velikost je typicky poslední volba
    out.colorValue = rest[0] || "";
    return out;
  }
  function colorKeyOf(value) {
    if (!value) return "";
    var hk = handleize(value);
    // Zkus, jestli takový klíč vůbec v nabídce existuje; když ne, zkus ještě shodu přes
    // celý název v témže jazyce. Když neprojde ani to, vrať handle a nabídka měkce spadne
    // na nejprodávanější dostupnou barvu.
    var pools = [].concat(Array.isArray(D.bottoms) ? D.bottoms : [], Array.isArray(D.premium) ? D.premium : []);
    for (var i = 0; i < pools.length; i++) {
      var cols = (pools[i] && pools[i].colors) || [];
      for (var j = 0; j < cols.length; j++) {
        if (cols[j].key === hk) return hk;
        if (cols[j].full && cols[j].full === value) return cols[j].key || hk;
      }
    }
    return hk;
  }

  // kam vrátit fokus: jen místo NA STRÁNCE, nikdy uvnitř popupu
  function rememberFocusOrigin() {
    var a = document.activeElement;
    if (a && a !== document.body && !(popEl && popEl.contains(a))) state.lastFocused = a;
  }

  var lastHandledVid = null, lastHandledAt = 0;

  function handleAdded(variantId, cartResponse) {
    lastHandledVid = String(variantId == null ? "" : variantId);
    lastHandledAt = Date.now();
    try {
      if (isPopupOpen()) return false;              // už otevřeno, druhý popup nedává smysl
      // Skelet i posluchače vždycky SPOLU: popup bez posluchačů by nešel zavřít, a to je
      // přesně ta past, kterou celý element slibuje, že nenastane.
      ensureBound();

      var item = itemOf(cartResponse, variantId);
      if (!isOutlet(item)) return false;            // běžný kus popup nespouští
      if (!isEnabled()) { log("popup je vypnutý"); return false; }

      var opt = optionsOf(item);
      state.anchor = {
        handle: item.handle || "",
        title: item.product_title || item.title || "",
        colorKey: colorKeyOf(opt.colorValue),
        colorValue: opt.colorValue,
        size: opt.size,
        key: item.key || null
      };
      state.anchorGone = false;
      if (cartResponse && cartResponse.sections) state.lastResponse = cartResponse;
      if (state.anchor.handle) cartHandles[state.anchor.handle] = true;

      var offer = decideOffer(state.anchor);
      if (!offer) { log("není co nabídnout"); return false; }   // drawer otevře motiv sám

      track("eligible", { anchor: state.anchor.handle, color: state.anchor.colorKey, size: state.anchor.size });
      // holdout: popup se nezobrazí, ale „eligible" je zalogované → měření inkrementality.
      // Přidání do košíku proběhlo normálně, jen se nad ním nic neotevře navíc.
      if (BUCKET === "holdout") { log("holdout, popup se nezobrazí"); return false; }

      rememberFocusOrigin();
      cartOpened = false;

      /* Od téhle chvíle ručíme za to, že se sidecart otevře. Watchdog: popup se musí
         vykreslit do 400 ms, jinak jede normální chování webu. */
      var cleared = false;
      var wd = setTimeout(function () {
        cleared = true;
        try { showPopup(false); } catch (e) {}
        openThemeCart("watchdog: popup se nevykreslil do 400 ms");
      }, 400);
      function clearWd() { if (!cleared) { cleared = true; clearTimeout(wd); } }

      /* Košík se dotahuje na pozadí a popup na něj nečeká. Když se /cart.js vrátí dřív než
         za 250 ms, zpřesní filtr „už v košíku" a součet pro bar; jinak se kreslí z dat sekce.
         Čekat na síť by znamenalo popup za watchdogem. */
      var drawn = false;
      function draw() {
        if (drawn || cleared) return;
        drawn = true;
        try {
          var o = decideOffer(state.anchor) || offer;
          renderPopup(o);
          requestAnimationFrame(function () {
            if (isPopupOpen() && popEl.offsetHeight > 0) {
              clearWd(); log("popup zobrazen");
              track("shown", { anchor: state.anchor.handle, offered: o.products.length });
            }
            else { clearWd(); showPopup(false); openThemeCart("popup se nevykreslil"); }
          });
        } catch (err) {
          // fail-open: jakákoli výjimka = popup se nezobrazí a zákaznice pokračuje dál
          clearWd();
          try { showPopup(false); } catch (e) {}
          openThemeCart("fail-open: " + (err && err.message ? err.message : err));
        }
      }
      var raceT = setTimeout(draw, 250);
      refreshCart(function () { clearTimeout(raceT); draw(); });

      return true;
    } catch (err) {
      // fail-open i v rozhodovací části: chováme se jako web bez tohohle elementu
      log("fail-open v rozhodování: " + (err && err.message ? err.message : err));
      try { showPopup(false); } catch (e) {}
      return false;
    }
  }

  /* ================= bindings ================= */
  /* Skelet a posluchače se stavějí jednou a vždycky dohromady. Když sekce element vypnula,
     nestaví se vůbec nic (žádný prázdný div v DOM); kdyby ho někdo zapnul za běhu
     z konzole, postaví se lazy při prvním přidání. */
  var bound = false;
  function ensureBound() { if (!bound) { bound = true; bind(); } }

  function bind() {
    if (!ensureDom()) return;
    applyView();
    // Od startu musí sedět inert i aria-hidden, ať se do zavřeného popupu nedá tabovat.
    setSurfaceActive(popEl, false);

    popEl.addEventListener("click", function (e) {
      /* Klik do ztmavení zavírá. Bere se i klik na kořen samotný, ne jen na .nou-pop__bg:
         ztmavení sedí na kořeni, takže popup se zavře i tehdy, kdyby v markupu sekce
         podkladový prvek chyběl. Hluchota proti dvojkliku platí i tady. */
      if (e.target === popEl) {
        if (!popEl.classList.contains("nou-armed")) closePopup("zavřeno klikem do ztmavení");
        return;
      }
      var t = e.target;
      while (t && t !== popEl) {
        if (t.hasAttribute && t.hasAttribute("data-nou-close")) {
          /* Hluchota pozadí se drží i v JS, nejen přes pointer-events v CSS: stylopis je
             samostatný asset a než se načte, spolkl by druhý klik z dvojkliku na „Přidat
             do košíku" celou nabídku. Tlačítek v panelu se to netýká, ta jdou hned. */
          if (t.classList.contains("nou-pop__bg") && popEl.classList.contains("nou-armed")) return;
          closePopup("zavřeno klikem");
          return;
        }
        t = t.parentNode;
      }
    });
    var go = $("#nouGo", popEl);
    if (go) go.addEventListener("click", function () { closePopup("CTA"); });   // stejná cesta ven jako odmítnutí

    document.addEventListener("keydown", function (e) {
      if (!isPopupOpen()) return;
      if (e.key === "Escape") { e.preventDefault(); closePopup("Esc"); return; }
      if (e.key !== "Tab") return;
      // Tab nesmí odejít z dialogu
      var panel = $("#nouPopPanel", popEl);
      var f = focusables(panel);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Vzájemné vyloučení povrchů proti TŘETÍMU zásahu do košíku. Blok dárku zdarma, sync
       z druhé záložky i rychlé přidání z dlaždice umí drawer otevřít vlastní cestou
       (motiv na to má i dokumentovanou událost cart:refresh s detail.open). Dokud visí
       popup, takový drawer hned zavřeme jeho vlastním API — dva otevřené povrchy naráz
       byly jediný nález, o kterém QA výslovně napsalo, že se přenese do ostré verze. */
    function suppressDrawer() {
      if (!isPopupOpen()) return;
      closeThemeCart();
      setTimeout(function () { if (isPopupOpen()) closeThemeCart(); }, 60);
    }
    document.addEventListener("cart:refresh", suppressDrawer);
    document.addEventListener("cartdrawer:opened", suppressDrawer);

    /* Cizí zásah do košíku z DRUHÉ ZÁLOŽKY nevyvolá tady žádnou událost, takže se stav karet
       srovná při návratu do záložky. Bez toho by karta visela v „✓ Přidáno" nad řádkem,
       který už v košíku není, a kus by nešlo přidat znovu. */
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible" && isPopupOpen()) refreshCart(syncFromCart);
    });

    /* Fallback pro případ, že hook v nebe-pdp.js není nasazený: posloucháme pub/sub motivu.
       Odloženo o tik schválně — motiv publikuje cartUpdate DŘÍV, než zavolá hook, takže bez
       odkladu by se handleAdded zavolal dvakrát a napodruhé by vrátil false („už otevřeno"),
       čímž by motiv otevřel drawer navíc k popupu. Takhle hook vždycky vyhraje. */
    try {
      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (!ev || ev.source === "nebe-outlet") return;       // vlastní změny ignorujeme
          var data = ev.cartData || ev.cart || null;
          var vid = ev.productVariantId || (data && (data.variant_id || data.id));
          // cizí zásah do košíku během popupu: karta nesmí viset v „✓ Přidáno" a drawer,
          // který si cizí kód otevřel, nesmí zůstat viset pod popupem
          if (isPopupOpen()) {
            suppressDrawer();
            setTimeout(function () { refreshCart(syncFromCart); }, 0);
            return;
          }
          if (!vid) return;
          setTimeout(function () {
            if (String(vid) === lastHandledVid && Date.now() - lastHandledAt < 1500) return;  // hook to už řešil
            if (window.nebeOutlet.handleAdded(vid, data)) log("popup přes pub/sub fallback");
          }, 0);
        });
      }
    } catch (e) {}
  }

  function syncFromCart(cart) {
    if (!isPopupOpen() || !cart || !Array.isArray(cart.items)) return;
    var keys = {};
    cart.items.forEach(function (i) { if (i && i.key) keys[i.key] = true; });
    cardRegistry.forEach(function (c) {
      var k = c.lineKey();
      if (c.isAdded() && k && !keys[k]) c.dropped();
    });
    cartChanged(false);
    // prázdný košík = není co nabízet, popup nemá důvod zůstat
    if (!cart.items.length) closePopup("košík se vyprázdnil");
  }

  /* ================= veřejné rozhraní ================= */
  window.nebeOutlet = {
    handleAdded: function (variantId, cartResponse) {
      try { return handleAdded(variantId, cartResponse) === true; }
      catch (e) { log("fail-open na vstupu: " + (e && e.message)); return false; }
    },
    close: function () { if (isPopupOpen()) closePopup("API"); },
    isOpen: isPopupOpen
  };

  /* ================= init ================= */
  try {
    if (isEnabled()) {
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { try { ensureBound(); } catch (e) {} });
      else ensureBound();
    }
    // košík na pozadí, ať je filtr „už v košíku" teplý ještě před prvním přidáním
    if (window.requestIdleCallback) requestIdleCallback(function () { refreshCart(); });
    else setTimeout(function () { refreshCart(); }, 1200);
  } catch (e) {
    // Start selhal: chováme se jako web bez tohohle elementu, handleAdded vrací false.
    log("start selhal (" + (e && e.message ? e.message : e) + "), jedu bez nabídky");
  }
})();
